export default "__VITE_ASSET__WXYG7f2B__"